import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'
import { getCurrentUser } from '../appRedux/actions/Auth'
import {
  Dashboard,
  Applications,
  ApplicationForm,
  Error404,
  ApplicationTracker,
  ViewApplication,
} from '../layouts'
import { Loader } from '../components'

const CSRoute = ({ component: Component, authUser, currentUser, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      !currentUser.is_installer ? (
        <>
          <Component {...props} />
        </>
      ) : (
        <Route component={Error404} />
      )
    }
  />
)

class AppRoutes extends Component {
  render() {
    const { authUser, currentUser, getCurrentUser } = this.props
    if (!currentUser) {
      getCurrentUser(authUser)
    }

    return (
      currentUser ?
        <Switch>
          <Route exact path="/dashboard" component={Dashboard} isSignedInUser />
          <Route exact path="/applications" component={Applications} isSignedInUser />
          <Route exact path="/applications/application-form" component={ApplicationForm} isSignedInUser />
          <Route exact path="/applications/:programId/view-application/:applicationId" component={ViewApplication} isSignedInUser />
          <CSRoute exact path="/applicationlist/:programId" component={ApplicationTracker} authUser={authUser} currentUser={currentUser} />
          <Route component={Error404} />
        </Switch >
        : <Loader loading={true} />
    )
  }
}

const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser } = auth
  return { authUser, currentUser }
}

const mapDispatchToProps = (dispatch) => ({
  getCurrentUser: () => dispatch(getCurrentUser()),
})

export default connect(mapStateToProps, mapDispatchToProps)(AppRoutes)
